import React from 'react'
import classnames from 'classnames'

import styles from '../styles.module.scss'

export const ErrorText: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <small className={classnames(styles.errorText, styles.errorMessage)}>{children}</small>
}
